__turbopack_context__.v({
  "item": "index-module-scss-module__VtloFq__item",
  "item__title": "index-module-scss-module__VtloFq__item__title",
  "root": "index-module-scss-module__VtloFq__root",
});
